<script lang="ts">
	import type { SbColor, SbImage, TextAlignment } from '../../types';
	import Image from '../../components/image.svelte';
	import SbRichtext from '../../components/sbRichtext.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import Blok from '$lib/storyblok/blok.svelte';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		content: ISbStoryData<{
			title: string | ISbRichtext;
			text: string | ISbRichtext;
			image_mobile?: SbImage;
			image_desktop?: SbImage;
			asset_mobile: ISbStoryData['content'][];
			asset_desktop: ISbStoryData['content'][];
			width_desktop: '1/3' | '1/2' | '2/3';
			background_color: SbColor;
			text_color: 'brown-2' | 'stone-5';
			text_align: TextAlignment;
			index: number;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="relative col-span-full aspect-3/4 overflow-hidden rounded-lg lg:aspect-4/3 lg:rounded-xl text-{content.text_color} bg-{content.background_color}"
	class:lg:col-span-4={content.width_desktop === '1/3'}
	class:lg:col-span-6={content.width_desktop === '1/2'}
	class:lg:col-span-8={content.width_desktop === '2/3'}
	class:text-center={content.text_align === 'center'}
>
	<div class="h-full w-full object-cover lg:hidden">
		{#if content.asset_mobile?.length > 0}
			<Blok content={content.asset_mobile[0]} />
		{:else if content.image_mobile?.filename}
			<Image
				class="h-full w-full object-cover"
				src={content.image_mobile.filename}
				title={content.image_mobile.title ?? ''}
				alt={content.image_mobile.alt ?? ''}
				width={1400}
			/>
		{/if}
	</div>

	<div class="h-full w-full max-lg:hidden">
		{#if content.asset_desktop?.length > 0}
			<Blok content={content.asset_desktop[0]} />
		{:else if content.image_desktop?.filename}
			<Image
				class="h-full w-full object-cover"
				src={content.image_desktop.filename}
				title={content.image_desktop.title ?? ''}
				alt={content.image_desktop.alt ?? ''}
				width={content.width_desktop === '2/3' ? 1500 : 1300}
			/>
		{/if}
	</div>

	<div
		class="absolute inset-x-6 top-6 flex justify-between text-[48px]/[110%] font-semibold text-[#FFE662]"
	>
		<div class="max-w-[320px]">
			<SbRichtext text={content.title} />
		</div>
		<p class="max-lg:hidden">{content.index}</p>
	</div>
	<div class="absolute inset-x-6 bottom-6 text-[16px]/[140%] lg:text-[20px]">
		<SbRichtext text={content.text} />
	</div>
</div>
